<div
  class="tooltip-dialog"
  [class.overlay-mode]="isOverlay"
  [class.floating-label-context]="data?.isFloatingLabelContext"
>
  <!-- Connection indicator for overlay mode -->
  @if (isOverlay) {
    <div
      class="tooltip-arrow"
      [class]="'tooltip-arrow-' + (data?.arrowPosition || 'top')"
    ></div>
  }

  <!-- Close button - always visible in top right corner -->
  <button
    mat-icon-button
    class="tooltip-dialog-close"
    (click)="close()"
    aria-label="Close tooltip"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="tooltip-dialog-content">
    <!-- Title with bottom padding -->
    @if (data.title) {
      <div class="tooltip-dialog-title">{{ data.title }}</div>
    }

    <!-- Content with top padding when title exists -->
    @if (!data.template) {
      <div
        [innerHTML]="data.content"
        class="tooltip-content"
        [class.has-title]="data.title"
      ></div>
    }
    @if (data.template) {
      <div class="tooltip-template-content" [class.has-title]="data.title">
        <ng-container
          *ngTemplateOutlet="
            data.template;
            context: { $implicit: data.data, content: data.content }
          "
        ></ng-container>
      </div>
    }
  </div>
</div>
